//------------ IMPORTAÇÕES ------------//
import { useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { loadReportService } from "../services";
import { TrafegoContext } from "../context/TrafegoContext";



//------------ EXPORTAÇÃO DA PÁGINA RELATÓRIO GRUPO ------------//
export default function ContainerFilters() {



    //------------ CRIAÇÃO DE HOOKS ------------//
    const { groups, setGroups } = useContext(TrafegoContext); // Estado que armazena a lista dos grupos existentes
    const { idGroupSelected, setIdGroupSelected } = useContext(TrafegoContext); // Estado que armazena o nome do Grupo selecionado pelo usuário
    const { startDateFilter, setStartDateFilter } = useContext(TrafegoContext); // Estado que armazena a Data Inicial selecionada pelo usuário
    const { endDateFilter, setEndDateFilter } = useContext(TrafegoContext); // Estado que armazena a Data Final selecionada pelo usuário
    const { report, setReport } = useContext(TrafegoContext); //  Estado que armazena a lista do Relatório



    //------------ FUNÇÃO ASSÍNCRONA BUSCAR RELATÓRIO ------------//
    const handleLoadReport = async () => {
        const response = await loadReportService(idGroupSelected, startDateFilter, endDateFilter)
        if (response) {
            setReport(response.data);
            console.log("Relatório carregado com sucesso:", response.data);
        }
    };



    //------------ RETORNO CONDICIONAL DA PÁGINA RELATÓRIO GRUPO ------------//
    return (
        <>
            {/* DIV DO FILTROS DE PESQUISA */}
            <div className="flex flex-col sm:flex-row gap-4 mb-6">

                {/* FILTRO POR GRUPO */}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Grupo</label>
                    <select
                        value={idGroupSelected}
                        onChange={(e) => setIdGroupSelected(e.target.value)}
                        className="h-[40px] w-full sm:w-auto bg-surface-2 border border-white/[0.08] px-3 py-2 rounded text-white"
                    >
                        <option value="">Selecione...</option>
                        {groups.map((g) => (
                            <option key={g.id} value={g.id}>{g.nome}</option>
                        ))}
                    </select>
                </div>

                {/* FILTRO DATA INICIAL */}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">De</label>
                    <input
                        type="date"
                        value={startDateFilter}
                        onChange={(e) => setStartDateFilter(e.target.value)}
                        className="h-[40px] bg-surface-2 border border-white/[0.08] px-3 py-2 rounded text-white w-full"
                    />
                </div>

                {/* FILTRO DATA FINAL */}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Até</label>
                    <input
                        type="date"
                        value={endDateFilter}
                        onChange={(e) => setEndDateFilter(e.target.value)}
                        className="h-[40px] bg-surface-2 border border-white/[0.08] px-3 py-2 rounded text-white w-full"
                    />
                </div>

                {/* BUTTON BUSCAR */}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label>&nbsp;</label>
                    <button
                        onClick={handleLoadReport}
                        className="h-[40px] bg-brand-600 hover:bg-brand-700 px-6 py-2 rounded w-full"
                    >
                        Buscar
                    </button>
                </div>

            </div>
        </>
    );
}